export default __webpack_public_path__ + "static/media/auth_top.dff1c8e5.svg";